var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarHalf = function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "star-half_svg__b",
    d: "M5.207.625h-.414L3.75 3.957H.207l2.848 2.121-1.18 3.715 3.332-2.457z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-half_svg__a",
    d: "m5 0 1.202 4L10 3.995 6.945 6.192 8.09 10 5 7.678 1.91 10l1.145-3.808L0 3.995 3.798 4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#d3d3d3",
    xlinkHref: "#star-half_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#star-half_svg__b"
  }))));
};
export default SvgStarHalf;